import { cookieStore } from '../../utils/polyfills/cookie-store';

export const initTrustPilot = async (setIsTrustPilotLoaded) => {
  if (typeof window === 'undefined') return;

  const wp21essential = await cookieStore.get('wp21essential');

  if (wp21essential && wp21essential.value === 'true') {
    addTrustPilot(setIsTrustPilotLoaded);
  }
}

export const addTrustPilot = (setIsTrustPilotLoaded) => {
  if (document.getElementById('trust-pilot-script')) {
    return;
  }

  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.id = 'trust-pilot-script'
  script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'

  head.appendChild(script);
  setIsTrustPilotLoaded(true);
}

